import AuditLogViewer from '../components/AuditLogViewer';

export default function AuditLog() {
  return (
    <div className="container mx-auto px-4 py-8">
      <AuditLogViewer />
    </div>
  );
}
